interface SberIconProps {
  status: 'active' | 'stopped' | 'canceled' | 'new'
  className?: string
}

export const SberIcon = (props: SberIconProps) => {
  const { status = 'new', className } = props
  const fillColor = {
    active: 'var(--status-green-fill)',
    stopped: 'var(--status-grey-fill)',
    canceled: 'var(--status-red-fill)',
    new: '#FFF',
  }[status]
  const pathColor = {
    active: 'var(--status-green-stroke)',
    stopped: 'var(--status-grey-stroke)',
    canceled: 'var(--status-red-stroke)',
    new: '#667085',
  }[status]

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill={fillColor} />
      <path
        d="M29.4949 12.6833C30.0618 13.4164 30.5356 14.2196 30.9364 15.0709L20.0136 23.1328L15.4258 20.2485V16.7974L19.9893 19.6576L29.4949 12.6833Z"
        fill={pathColor}
      />
      <path
        d="M10.7656 20.0104C10.7656 19.8442 10.7656 19.7039 10.7899 19.5377L8.0243 19.3955C8.0243 19.5858 8 19.7981 8 19.9864C8 23.2973 9.3484 26.2997 11.5228 28.4749L13.4847 26.512C11.8063 24.8576 10.7656 22.5642 10.7656 20.0104Z"
        fill={pathColor}
      />
      <path
        d="M19.9884 10.7916C20.1544 10.7916 20.2961 10.7916 20.4622 10.8156L20.6039 8.0495C20.4136 8.0495 20.201 8.02547 20.0127 8.02547C16.7024 8.02547 13.6999 9.37346 11.5234 11.5487L13.4853 13.5116C15.1414 11.8331 17.4576 10.7916 19.9884 10.7916Z"
        fill={pathColor}
      />
      <path
        d="M19.9866 29.2339C19.8206 29.2339 19.6788 29.2339 19.5128 29.2099L19.3711 31.976C19.5614 31.976 19.774 32 19.9623 32C23.2725 32 26.2771 30.652 28.4515 28.4768L26.4897 26.5139C24.8335 28.2164 22.5396 29.2339 19.9866 29.2339Z"
        fill={pathColor}
      />
      <path
        d="M25.1895 12.3985L27.53 10.672C25.473 9.01751 22.8491 8 19.9883 8V10.7661C21.9279 10.7901 23.7237 11.381 25.1895 12.3985Z"
        fill={pathColor}
      />
      <path
        d="M32.0003 20.0121C32.0003 19.279 31.9295 18.5699 31.81 17.8609L29.2327 19.7757C29.2327 19.8458 29.2327 19.942 29.2327 20.0121C29.2327 22.7321 28.0503 25.1677 26.1836 26.8462L28.0503 28.9032C30.4637 26.728 32.0003 23.5353 32.0003 20.0121Z"
        fill={pathColor}
      />
      <path
        d="M19.9878 29.232C17.2687 29.232 14.8331 28.0502 13.1547 26.1814L11.0977 28.0502C13.2964 30.4858 16.4649 31.9981 19.9878 31.9981V29.232Z"
        fill={pathColor}
      />
      <path
        d="M13.8167 13.1772L11.948 11.1201C9.5124 13.3194 8 16.4881 8 20.0113H10.7656C10.7656 17.3153 11.948 14.8577 13.8167 13.1772Z"
        fill={pathColor}
      />
    </svg>
  )
}
